import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  dummyAvatar,
  profileSettingIcon,
  signoutIcon,
} from '../assets/superAdminAssets';
import { logout } from '../services/login.service';
import { useAppContext } from '../contexts/AppContext';
import { useUser } from '../store/hooks/useUser';
import { Constants } from '../constants';
import { CookieNames, getCookie } from '../helpers/cookie.helper';

/**
 * Reusable page header with section title and user profile dropdown.
 *
 * Props:
 * - title: string - section title to display (e.g. "Dashboard")
 * - onLogoutClick?: () => void - optional handler when "Sign Out" is clicked
 * - useLogoutModal?: boolean - if true, uses <a> with data-toggle for modal; otherwise plain Link to /login
 */
const Header = ({ title }) => {
  const { showLoader, hideLoader, showToaster, hideToaster } = useAppContext();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const navigate = useNavigate();
  const { user, clearUser } = useUser();

  const handleLogoutClick = async (e) => {
    e.preventDefault();
    setShowDeletePopup(false);
    try {
      showLoader();
      await logout(getCookie(CookieNames.EMAIL));
      hideLoader();
      clearUser();
      navigate('/login', { replace: true });
    } catch (error) {
      console.log(error);
      showToaster("Something went wrong while logging out. Please try again.", 'error');
      setTimeout(() => hideToaster(), Constants.TOASTERHIDETIME);
    } finally {
      hideLoader();
    }
  };

  return (
    <>
      <div className="profile-header">
        <div className="hamburger">
          <div className="line1" />
          <div className="line2" />
          <div className="line3" />
        </div>
        <div className="section-name">
          <h6>{title}</h6>
        </div>
        <div className="user-dtl w-25 justify-content-end">
          <div className="user-pro-pic">
            <img src={user.imagePath || dummyAvatar} alt="User avatar" />
          </div>
          <div className="dtl-sec">
            <div className="user-name">{user.name}</div>
            <p className="user-designation mb-0">{user.roleName}</p>
            <div className="logout-dropdown">
              <Link to="/settings">
                <img src={profileSettingIcon} alt="" />
                Profile Settings
              </Link>
              <a
                href="#"
                data-toggle="modal"
                data-target="#logoutPopup"
                onClick={() => setShowDeletePopup(true)}
              >
                <img src={signoutIcon} alt="" />
                Sign Out
              </a>
            </div>
          </div>
        </div>
      </div>

      {showDeletePopup && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowDeletePopup(false)}
          ></div>
          <div className="modal show d-block fade signout-modal" id="deletePopup" tabIndex="-1" role="dialog" aria-labelledby="deletePopupLabel"
            aria-hidden="false">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body">
                  <h3 className="pt-4">Are you sure you want to logout?</h3>
                </div>
                <div className="modal-footer border-0">
                  <button type="button" className="lm-button2" data-dismiss="modal" onClick={() => setShowDeletePopup(false)}>Cancel</button>
                  <button type="button" className="lm-button1" onClick={(e) => handleLogoutClick(e)}>Confirm</button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;

